import Api from "@src/api";
export const VideoApi = {
  getManualVideos(params) {
    return Api().get(`ManualVideo`, { params });
  },

  getManualVideoById(id) {
    return Api().get(`ManualVideo/${id}`);
  },

  createManualVideo(data) {
    return Api().post(`ManualVideo`, data);
  },

  updateManualVideo(data) {
    return Api().put(`ManualVideo`, data);
  },

  deleteManualVideo(id) {
    return Api().delete(`ManualVideo/${id}`);
  },
  getListCate() {
    return Api().get(`VideoCategory`);
  },
  getAllMachineVideo(paramsString = "") {
    return Api().get(
      "MachineNewForSiteOffice/getMachineByVideo?" + paramsString
    );
  },
  getCheckItem(params) {
    return Api().get("CheckItem", { params });
  },
  getListTag(params) {
    return Api().get("Tag", { params });
  },
  getVideoComments(params) {
    return Api().get(`VideoComment`, { params });
  },

  getVideoCommentById(id) {
    return Api().get(`VideoComment/${id}`);
  },

  createVideoComment(data) {
    return Api().post(`VideoComment`, data);
  },

  updateVideoComment(data) {
    return Api().put(`VideoComment`, data);
  },

  deleteVideoComment(id) {
    return Api().delete(`VideoComment/${id}`);
  },
  createVideoPlaylist(data) {
    return Api().post(`VideoPlaylist`, data);
  },
  deletePlayList(params) {
    return Api().delete(`VideoPlaylist`, {
      params,
    });
  },

  getVideoPlaylists() {
    return Api().get(`VideoPlaylist`);
  },

  deleteVideoPlaylist(id) {
    return Api().delete(`VideoPlaylist/${id}`);
  },
  getVideoByIdCheck(id) {
    return Api().get("ManualVideo/getCheckItemId", {
      params: {
        checkItemId: id,
      },
    });
  },
  getAllVideoPlayList(params) {
    return Api().get("VideoPlaylist/getAllVideo", {params});
  },
  getVideoByMachine(id) {
    return Api().get("ManualVideo/getMachineCode", {
      params: {
        machineCode: id,
      },
    });
  },
  getHomeBannerVideo(id) {
    return Api().get("ManualVideo/getHomeBannerVideo", {
      params: {
        machineCode: id,
      },
    });
  },
  addCountView(id) {
    return Api().get("ManualVideo/getCountView", {
     params:{
      videoId:id
     }
      },
    );
  },
  getAllItemByMachine(params){
    return  Api().get("/CheckItem/getAllListCheckItem",{params})
  },
  getAllVideoInstruction(params) {
    return Api().get("ManualVideo/getAllSpecialVideo", {params});
  },
  getAllVideoRecent(params) {
    return Api().get("ManualVideo/getAllRecentVideo", {params});
  },
};
